<template>
  <div>
    <report-table
      :headers="reportHeaders"
      :items="items"
      :initialSortedColumns="['department']"
    />
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import reportMixin from "@/views/reports/mixins/reportMixin";
import ReportTable from "@/views/reports/components/reportSections/reportTable/ReportTable.vue";
import { csvDataMapper } from "@/views/reports/utils/csvDataMapper";

export default {
  mixins: [reportMixin],
  components: { ReportTable },
  data() {
    const commonHeaders = [
      {
        text: i18n.t("reports.sa.headers.department"),
        value: "department",
        sortable: true,
        class: "tw-align-text-top"
      },
      {
        text: i18n.t("reports.sa.headers.employee-name"),
        value: "employeeName",
        sortable: true,
        class: "tw-align-text-top"
      },
      {
        text: i18n.t("reports.sa.headers.employee-identifier"),
        value: "employeeIdentifier",
        sortable: true,
        class: "tw-align-text-top"
      },
      {
        text: i18n.t("reports.sa.headers.badge-type"),
        value: "badgeType",
        sortable: true,
        class: "tw-align-text-top"
      },
      {
        text: i18n.t("reports.sa.headers.serial-number"),
        value: "serialNumber",
        sortable: true,
        class: "tw-align-text-top"
      },
      {
        text: i18n.t("reports.sa.headers.battery-status"),
        value: "currentBatteryStatus",
        sortable: true,
        class: "tw-align-text-top"
      }
    ];

    return {
      compatibleReportId: 44,
      allowEmptyReportFilters: true,
      reportHeaders: [...commonHeaders],
      csvHeaders: [...commonHeaders],
      items: [],
      reportFilters: [],
      hiddenReportActions: ["rawExport", "saveSlide"]
    };
  },
  methods: {
    createCsvData() {
      const headers = this.csvHeaders;
      const headersText = headers.map((header) => header.text);
      const data = csvDataMapper(this.items, headers);

      this.$store.commit("reports/setCsvData", {
        headersText,
        data
      });
    },
    handleReportResponse() {
      const items = this.reportResponse.dataPoints;
      this.items = items.map((item) => ({
        department: item.department,
        employeeName: item.employeeName,
        employeeIdentifier: item.employeeIdentifier,
        badgeType: item.badgeType,
        serialNumber: item.serialNumber,
        currentBatteryStatus: item.currentBatteryStatus
      }));
    }
  }
};
</script>
